import { Link as RouterLink } from 'react-router-dom';
import moment from "moment-timezone";
import { Link, TableCell, TableContainer } from '@mui/material';
import MuiTable from '@components/common/MuiTable';
import { NILL } from '@lib/constants';
import { defaultComparator } from '@lib/utils';
import { getEventDates, getEventStatusIcon, getStatusOrd } from '../eventFunctions';
import StatusLegend from '../Sessions/StatusLegend';

const headCells = [
  {
    id: 'event_name',
    label: 'Event Name',
  },
  {
    id: 'curriculum_name',
    label: 'Curriculum / Booth',
  },
  {
    id: 'sessions',
    label: 'Completed Sessions',
  },
  {
    id: 'session_dates',
    label: 'Session Dates',
  },
  {
    id: 'created_by',
    label: 'Created By',
  },
  {
    id: 'status',
    label: 'Status',
  },
];

/**
 * Returns a comparison function.
 *
 * @param order
 * @param orderBy
 */
const getComparator = (order, orderBy) => {
  const ord = order === 'desc' ? -1 : 1;
  switch (orderBy) {
    case 'session_dates':
      return (a, b) => {
        if (a === b) return 0;
        if (!a?.sessionSummary?.first) return -1 * ord;
        if (!b?.sessionSummary?.first) return 1 * ord;
        return moment(a.sessionSummary.first).diff(moment(b.sessionSummary.first)) * ord;
      };
    case 'sessions':
      const getTotal = (e) =>
        !e?.sessionSummary ? 0 : e?.sessionSummary?.completed / (e?.sessionSummary?.total || 1);
      return (a, b) => {
        let diff = getTotal(a) - getTotal(b);
        if (diff === 0) {
          diff = (a?.sessionSummary?.total || 0) - (b?.sessionSummary?.total || 0);
        }
        return diff * ord;
      };
    case 'status':
      return (a, b) => (getStatusOrd(a) - getStatusOrd(b)) * ord;
    case 'event_name':
    case 'curriculum_name':
    case 'created_by':
      return (a, b) => {
        // Sort on these fields ignores leading/trailing whitespace.
        return a[orderBy].trim().localeCompare(b[orderBy].trim()) * ord;
      };
    default:
      return defaultComparator;
  }
};

const EventsTable = (props) => {
  const { events } = props;

  return (
    <>
      <StatusLegend />
      <TableContainer>
        <MuiTable
          defaultOrderBy="event_name"
          headCells={headCells}
          getComparator={getComparator}
          data={events}
        >
          {(row) => (
            <>
              <TableCell component="th" scope="row" data-cy="name-cell">
                <Link to={`/events/${row.id}`} component={RouterLink}>
                  {row.event_name}
                </Link>
              </TableCell>
              {/** curriculum, completed sessions, session dates, created by, status **/}
              <TableCell align="left" data-cy="curriculum-cell">{row.curriculum_name || NILL}</TableCell>
              <TableCell align="left" data-cy="session-counts-cell">
                {row.sessionSummary
                  ? `${row.sessionSummary.completed} / ${row.sessionSummary.total}`
                  : NILL}
              </TableCell>
              <TableCell align="left" data-cy="date-cell">
                {getEventDates(row)}
              </TableCell>
              <TableCell align="left" data-cy="create-by-cell">{row.created_by_names}</TableCell>
              <TableCell align="left" data-cy="status-cell">{getEventStatusIcon(row)}</TableCell>
            </>
          )}
        </MuiTable>
      </TableContainer>
    </>
  );
};

export default EventsTable;
